// Shared request service for the viewer and EOS uploader. Keeping this in a
// standalone module mirrors test-oss's ApiServer dependency direction and
// avoids an api.js <-> EOS uploader cycle in WebView bundles.
let client = null

export function configureTaskService(nextClient) {
  client = nextClient || null
}

function toRequestOptions(options = {}) {
  const requestOptions = {
    method: String(options.method || 'GET').toUpperCase(),
    headers: options.headers || {},
    signal: options.signal,
    timeout: Number(options.timeout) > 0 ? Number(options.timeout) : 30 * 1000
  }
  if (options.data !== undefined) requestOptions.body = JSON.stringify(options.data)
  else if (options.body !== undefined) requestOptions.body = options.body
  return requestOptions
}

export const ApiServer = {
  async request(options = {}) {
    if (!client) throw new Error('EOS API 未初始化')
    const path = options.url || options.path || ''
    return { data: await client.request(path, toRequestOptions(options)) }
  },
  async publicRequest(options = {}) {
    return this.request(options)
  }
}
